import React from "react";
var __jsx = React.createElement;
import { CDN_LINK } from "@globalConfig";
import { useTranslation } from "@i18n";
var ComparisonImportanceSection = function ComparisonImportanceSection() {
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var items = [{
    image: CDN_LINK + "/assets/images/compare/importance1.png",
    title: tShort("compare/importance_title1", {
      ns: "web_common"
    }),
    description: tShort("compare/importance_description1", {
      ns: "web_common"
    })
  }, {
    image: CDN_LINK + "/assets/images/compare/importance2.png",
    title: tShort("compare/importance_title2", {
      ns: "web_common"
    }),
    description: tShort("compare/importance_description2", {
      ns: "web_common"
    })
  }, {
    image: CDN_LINK + "/assets/images/compare/importance3.png",
    title: tShort("compare/importance_title3", {
      ns: "web_common"
    }),
    description: tShort("compare/importance_description3", {
      ns: "web_common"
    })
  }];
  return /*#__PURE__*/React.createElement("section", {
    className: "bg-[#F4F9FE] py-16 px-4 lg:px-20"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-center mb-10"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-3xl font-bold mb-2 text-primary"
  }, tShort("compare/importance", {
    ns: "web_common"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap justify-center gap-6 mx-auto"
  }, items.map(function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "bg-white w-[370px] rounded-2xl border border-[#D6DFE9] shadow-md py-6 px-5 text-center flex flex-col items-center min-h-[326px]"
    }, /*#__PURE__*/React.createElement("img", {
      src: item.image,
      alt: item.title,
      className: "w-[186px] h-[128px] object-contain mb-3",
      height: 128,
      width: 186,
      loading: "lazy"
    }), /*#__PURE__*/React.createElement("h3", {
      className: "text-xl font-bold mb-2 text-primary"
    }, item.title), /*#__PURE__*/React.createElement("p", {
      className: "text-[#484848] leading-8"
    }, item.description));
  })));
};
export default ComparisonImportanceSection;